import type { IxcFundingV1BatchTransferKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FUNDING_BATCH_TRANSFER_BASE_PATH = getResolvedPath('/funding/batch-transfer');

export const getFundingTransferPath: EntityPathBuilder<IxcFundingV1BatchTransferKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FUNDING_BATCH_TRANSFER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.batchTransferId) {
        return undefined;
      }

      return getResolvedPath(`${FUNDING_BATCH_TRANSFER_BASE_PATH}/$batchTransferId`, context.keys);
    }
  }
};

export function getFundingBatchTransferDetailPath(batchTransferId: string | undefined) {
  if (!batchTransferId) {
    return undefined;
  }

  return getFundingTransferPath({ kind: 'detail', keys: { batchTransferId } });
}
